exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.lxm-more[data-v-752360d6] {\n  text-align: center;\n}\n.lxm-more__button[data-v-752360d6] {\n  padding: 1.07rem;\n  font-size: 0.71rem;\n}\n", "", {"version":3,"sources":["/./src/components/Main/common/src/components/Main/common/LxmMore.vue","/./src/components/Main/common/LxmMore.vue"],"names":[],"mappings":";AAeA;EACE,mBAAA;CCdD;ADeD;EACE,iBAAA;EACA,mBAAA;CCbD","file":"LxmMore.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n@import '../../styles/index.styl'\n.lxm-more\n  text-align: center\n.lxm-more__button\n  padding: spacing\n  font-size: size-smaller\n",".lxm-more {\n  text-align: center;\n}\n.lxm-more__button {\n  padding: 1.07rem;\n  font-size: 0.71rem;\n}\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/vue-loader/lib/style-rewriter.js?id=data-v-752360d6&scoped=true!./~/stylus-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Main/common/LxmMore.vue
// module id = 648
// module chunks = 0